<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-06 09:51:07
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-07-12 16:58:22
 * @FilePath: /content-center/src/components/wiki/SelectDiseases.vue
-->
<template>
  <div class="content-item flex align-items-center">
    <div class="content-item-label">
      <span class="red" v-if="JSON.parse(commonData[0].value) === '1'">*</span
      >{{ JSON.parse(commonData[1].value) || "选择疾病" }}
    </div>
    <el-select
      v-model="diseaseId"
      multiple
      filterable
      remote
      placeholder="请输入疾病"
      :remote-method="diseaseRemoteMethod"
      @change="writeChange"
      :loading="diseaseLoading"
    >
      <el-option
        v-for="item in diseaseOptions"
        :key="item.diseaseId"
        :label="item.diseaseName"
        :value="item.diseaseId"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { request } from "@/utils/axios";

export default {
  name: "selectDisease",
  props: ["functionIds", "contentId", "commonData"],
  data() {
    return {
      // 关联症状疾病
      diseaseLoading: false,
      diseaseOptions: [],
      diseaseId: []
    };
  },
  methods: {
    writeChange(value) {
      if (value == "") {
        this.diseaseOptions = [];
      } else {
        if (value.length > Number(JSON.parse(this.commonData[2].value))) {
          this.$message.error(
            `最多选择${Number(JSON.parse(this.commonData[2].value))}个疾病`
          );
          this.diseaseId = value.filter((item, index) => {
            return index < Number(JSON.parse(this.commonData[2].value));
          });
        }
      }
    },
    // writeChange(value) { TODO:一个症状可以绑定同一个疾病  请求接口
    //   if (value == "") {
    //     this.diseaseOptions = [];
    //   } else {
    //     let contentDiseases = value.map(val => ({ diseaseId: val }));
    //     if (value.length > Number(JSON.parse(this.commonData[2].value))) {
    //       this.$message.error(
    //         `最多选择${Number(JSON.parse(this.commonData[2].value))}个疾病`
    //       );
    //       this.diseaseId = value.filter((item, index) => {
    //         return index < Number(JSON.parse(this.commonData[2].value));
    //       });
    //     } else {
    //       request("health_cmp_contentValidate", {
    //         validationDTO: { name: "diseaseUnique" },
    //         componentCode: "common-wiki-select-disease",
    //         contentBizDTO: {
    //           contentType: this.$route.query.type,
    //           contentId: this.contentId,
    //           tenantId: this.$route.query.tenantid,
    //           contentDiseases
    //         }
    //       })
    //         .then(res => {})
    //         .catch(err => {
    //           this.$message.error(err.msg);
    //           this.diseaseId = value.filter((item, index) => {
    //             return index < Number(value.length - 1);
    //           });
    //         });
    //     }
    //   }
    // },
    //关联疾病症状搜索
    diseaseRemoteMethod(query) {
      if (query !== "") {
        this.diseaseLoading = true;
        request("health_cmp_pageDiseaseInfoByParam", {
          tenantId: this.$commonJs.getTenantId(),
          diseaseName: query
        })
          .then(res => {
            console.log('res---- 106', res)
            this.diseaseOptions = res?.data || [];
            this.diseaseLoading = false;
          })
          .catch(err => {
            this.diseaseOptions = [];
            this.diseaseLoading = false;
          });
      } else {
        this.diseaseOptions = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
